import React, {useContext } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/AllMainmenu'
import Table from '../../Components/AllTableComponent'
// import {PE_VC_TABLE_QUERY} from '../../Queries/Pe';
import Card from '../../Components/ListPageCard/AngelCard'
import RefineSearch from '../../Components/RefineSearchComponent'
import FilterTag from '../../Components/Tag'
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import Constants from '../../Constants';
import AngelRefineSearch from '../../Components/RefineSearch/AngelRefineSearch';
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { Switch, Tooltip } from "antd";
import { UserContext } from "../../Contexts/UserContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../../hooks/useChartAnalytics";

/**
 * The function `Vc` is a React component that renders a layout with a top navigation bar, a main area
 * with a primary column and a secondary column, and a bottom section. The primary column contains a
 * filter tag, a main menu, and a table. The secondary column contains a refine search component.
 * @returns The function `Vc` returns JSX elements that make up the layout of a page. It includes a top
 * navigation section, a main area with a primary column and a secondary column, and a bottom section.
 * The primary column contains a filter tag, a main menu, and a table. The secondary column contains a
 * refine search component.
 */
function Vc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation();
    const { pathname } = useLocation(); 
 
    const { refineSearchFilters, dealsView, setDealsView, switchValue, setSwitchValue , isMobile} = useContext(PeFilterContext);
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const { isDirectoryUser } = useContext(UserContext);

    // Use chart analytics hook
    const {
        showChartPopup,
        setShowChartPopup,
        currentChartData,
        setCurrentChartData,
        isChartLoading,
        setIsChartLoading,
        currentShowBy,
        fallbackChartData,
        getAvailableShowByOptions,
        handleChartIconClick,
        handleShowByChange,
        interval,
        handleIntervalChange,
        period,
        handlePeriodChange
    } = useChartAnalytics("vc-angel", pathname);

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    return (
        <Layout>
        <div className="flex h-screen flex-col">
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 mt-12 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 overflow-y-auto flex-col lg:order-last">
                                {/* Your content */}
                                <div className="mr-[4.25rem] flex justify-between items-center">
                                <div></div>
                                <ToggleDealsViewButton />
                                </div>
                                {/* <div className='px-3'> */}
                                <MainMenu 
                                    active={4} 
                                    menu="angel" 
                                    primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                    subTypeMasterId={Constants.primaryMasterSubIds.vc_angel_invesments_id}
                                    typeId={Constants.moduleIds.companiesId}
                                    exportFileName={Constants.exportNames.vc_company_angel}
                                    handleChartIconClick={handleChartIconClick}
                                    isChartLoading={isChartLoading}
                                /> 
                                <div className='overflow-y-auto'>
                                    <Table menu="vc-angel" sub_type_master_id={Constants.subCategoryIds.vc_angel_invesments_id}/>
                                </div>
                                {/* </div> */}
                            </section>
                           
                        </main>
                    </div>
                    
                </div>
                
                {/* Chart Popup */}
                {showChartPopup && (
                    <ChartPopup
                        isOpen={showChartPopup}
                        onClose={() => {
                            setShowChartPopup(false);
                            setIsChartLoading(false);
                            setCurrentChartData(null);
                        }}
                        data={currentChartData || fallbackChartData}
                        isLoading={isChartLoading}
                        showBy={currentShowBy}
                        availableShowByOptions={getAvailableShowByOptions()}
                        onShowByChange={handleShowByChange}
                        interval={interval}
                        onIntervalChange={handleIntervalChange}
                        period={period}
                        onPeriodChange={handlePeriodChange}
                        menuType="vc-angel"
                        subType="Angel Investments"
                    />
                )}
        </Layout>
    )
}

export default Vc